import React from 'react';
import { createRoot } from 'react-dom/client';
import './app.css';
import { App } from './app/App';
import { registerSW } from './pwa/register-sw';
import { setupGlobalErrorHandlers } from './lib/globalErrorHandlers';
import { initSentry } from './lib/sentry';

// Setup global error handlers before rendering
initSentry();
setupGlobalErrorHandlers();
registerSW();

const container = document.getElementById('app');
if (!container) {
  throw new Error('Missing #app container in index.html');
}

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
